import { BusinessUnitEmailContactSearchComponentBase } from './business-unit-email-contact-search.component.base';
import { Component, Injector } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { BusinessUnitEmailContactService, BusinessUnitService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-business-unit-email-contact-search',
  templateUrl: './business-unit-email-contact-search.component.html',
  styleUrls: ['./business-unit-email-contact-search.component.scss']
})
export class BusinessUnitEmailContactSearchComponent extends BusinessUnitEmailContactSearchComponentBase {

  displayedColumns: string[] = [ 'businessUnitEmailContactId', 'businessUnit.buId', 'addrType', 'description', 'email', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate', 'actions'];
  disabledColumns: string[] = [ 'createdBy', 'createdDate', 'updatedBy', 'updatedDate'];

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected businessUnitEmailContactService: BusinessUnitEmailContactService,
    protected businessUnitService: BusinessUnitService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, businessUnitEmailContactService, businessUnitService, refCodeStorage, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.businessUnitLoadSelectionList();
    this.addrTypeLoadSelectionList();
    
    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }
  
  resetSearchForm() {
    // placeholder
  }
  
  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }
  
}



